import { routeList } from '@/router/helpers/routes'

export const CARDS_TOPUPMODES = {
	FLEX_TOPUP: 'FLEX_TOPUP',
	KAMBA_DIRECT_TOPUP: 'KAMBA_DIRECT_TOPUP',
	KAMBA_REQUEST_TOPUP: 'KAMBA_REQUEST_TOPUP',
	VIRTUAL_DIRECT_TOPUP: 'CVISA_VIRT_TOPUP',
	MCX_DIRECT_TOPUP: 'MCX_DIRECT_TOPUP'
}

export const CARDS_TRANSFER_ROUTES = {
	FLEX_TOPUP: routeList.CARDS_TRANSFERS_FLEX_NAME
}

export const CARDS_TOPUP_ROUTES = {
	KAMBA_DIRECT_TOPUP: routeList.CARDS_CHARGE_DIRECT_KAMBA_NAME,
	FLEX_TOPUP: routeList.CARDS_CHARGE_FLEX_NAME,
	CVISA_VIRT_TOPUP: routeList.CARDS_CHARGE_VIRTUAL_NAME,
    MCX_DIRECT_TOPUP: routeList.CARDS_CHARGE_MULTICAIXA_NAME
}

export const CARDS_TYPE_EMITTER = {
	EMISMCX: 'EMISMCX'
}

export const CARDS_TYPE = {
	BAICARD: 'BAICARD'
}

export const CARDS_PRODUCT = {
	MCX_CREDIT: 'MCX_CREDIT',
	EMP_MCX_CR: 'EMP_MCX_CR',
	MCX_PPNP: 'MCX_PPNP_',
	PERSON_EMV: 'PERSON_EMV',
	N_PERS_EMV: 'N_PERS_EMV',
	'N-PERS-EMV': 'N-PERS-EMV'
}
